module.exports = __webpack_public_path__ + "img/Down_Hold_Body_Active.adc2d5a2.png";